import React from "react";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Navbar from "./components/navBar/Navbar";
import Footer from "./components/footer/Footer";
import About from "./pages/Home/About";
import Contact from "./pages/contact/Contact";
import ScrollTop from "./components/scrollTop/ScrollTop";
import Instruments from "./pages/instruments/Instruments";
import PrivacyPolicy from "./pages/policy/PrivacyPolicy";
import { TermsofService } from "./pages/policy/TermsofService";
import { Disclaimer } from "./pages/policy/Disclaimer";
import TrackRecord from "./pages/trackRecord/TrackRecord";

//axios.defaults.baseURL = "http://localhost:6035/api/v1";
axios.defaults.baseURL = "https://api.intellitech.ae/api/v1";
axios.defaults.withCredentials = true;

const App = () => {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Navbar />
      <Routes>
        <Route path= "*" element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/track-record" element={<TrackRecord />} />
        <Route path="/instruments" element={<Instruments />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsofService />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
